import { motion } from 'framer-motion';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Photo.module.css';

import hum from '../../assets/images/hum.webp';

export const Photo = ({ message, rotateSign, startDutation }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const errorAttachHandler = (e) => {
    e.target.src = hum;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={styles.photo} key={message.id}>
      <div className={styles.avatarBlock}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0 }}
          className={styles.avatar}
        >
          <div
            className={styles.avatarBg}
            style={{
              background: `url(${
                iconsSources[message?.channel]
              }) center/cover no-repeat `,
            }}
          />
          <img src={srcAvatar} alt={''} onError={errorHandler} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className={styles.author}
        >
          {message?.author || hideNumber(message?.senderNumber)}
        </motion.div>
      </div>

      <div className={styles.contentWrapper}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className={styles.topBorder}
        />
        <motion.div
          initial={{ scale: 0, originX: 'left', originY: 'top' }}
          animate={{ scale: 1, originX: 'left', originY: 'top' }}
          transition={{ duration: 0.5, delay: 1 }}
        >
          <img
            onError={errorAttachHandler}
            src={message?.attachments[0]?.url}
            alt={''}
            className={styles.attach}
          />
        </motion.div>
      </div>
    </div>
  );
};
